export enum ReturnOrderStatus {
  CANCEL = 0,
  WAITING_DEPLOY = 10,
  PROCESSING = 20,
  CHECKED = 50,
  FINISH = 70,
}

export const returnOrderStatusLabel: { [key in ReturnOrderStatus]: string } = {
  [ReturnOrderStatus.CANCEL]: "取消",
  [ReturnOrderStatus.WAITING_DEPLOY]: "待拋單",
  [ReturnOrderStatus.PROCESSING]: "已拋單/待處理",
  [ReturnOrderStatus.CHECKED]: "已驗收",
  [ReturnOrderStatus.FINISH]: "已驗入",
};

export const returnOrderStatusOptions = [
  ReturnOrderStatus.CANCEL,
  ReturnOrderStatus.WAITING_DEPLOY,
  ReturnOrderStatus.PROCESSING,
  ReturnOrderStatus.CHECKED,
  ReturnOrderStatus.FINISH,
].map((value) => ({
  label: returnOrderStatusLabel[value],
  value,
}));

// 退貨類型：既有 API 欄位 isReturnToWarehouse 維持 boolean，僅顯示文案由「是否入庫」改為「退貨類型」
export const returnTypeOptions: { label: string; value: boolean }[] = [
  { label: "入庫", value: true },
  { label: "報廢", value: false },
];
